import { FormGroup, Validators } from '@angular/forms';

export function firstDateBeforeSecond(firstDate: string, secondDate: string) {
  return (group: FormGroup): { [key: string]: any } => {
    let first = group.controls[firstDate].value;
    let second = group.controls[secondDate].value;
    if (first > second) {
      return {
        firstAfterSecond: first > second
      };
    }
  };
}



// WEBPACK FOOTER //
// ./src/app/validators/first-date-before-second.ts